import { render, staticRenderFns } from "./ObligatoryStateLine.vue?vue&type=template&id=72777e2d&scoped=true&lang=html&"
import script from "./ObligatoryStateLine.vue?vue&type=script&lang=js&"
export * from "./ObligatoryStateLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72777e2d",
  null
  
)

export default component.exports